import React, { useState, useEffect, useRef } from "react";
import { IoClose } from "react-icons/io5";
import { FaStar, FaUpload } from "react-icons/fa";
import { BASE_URL } from '../../../utils/configConstants';
import "./AddTestimonialModal.css";

const getMediaUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${BASE_URL}${path.replace(/^\//, '')}`;
};

const AddTestimonialModal = ({ 
    showModal, 
    isEditMode, 
    selectedItem, 
    onSave, 
    onClose, 
    saveLoading 
}) => {
    const [userName, setUserName] = useState("");
    const [rating, setRating] = useState(0);
    const [testimonial, setTestimonial] = useState("");
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [hoverRating, setHoverRating] = useState(0);
    const fileInputRef = useRef(null);

    useEffect(() => {
        if (showModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [showModal]);

    useEffect(() => {
        if (showModal) {
            if (isEditMode && selectedItem) {
                setUserName(selectedItem.user_name || selectedItem.name || "");
                setRating(selectedItem.rating || 0);
                setTestimonial(selectedItem.testimonial || "");
                
                const imagePath = selectedItem.profile_image;
                if (imagePath) {
                    console.log("image path is here: -",imagePath);
                    setImagePreview(getMediaUrl(imagePath));
                } else {
                    setImagePreview(null);
                }
            } else {
                setUserName("");
                setRating(0);
                setTestimonial("");
                setImage(null);
                setImagePreview(null);
            }
            
        }
    }, [showModal, isEditMode, selectedItem]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    // const handleRatingNumberInput = (e) => {
    //     const val = parseInt(e.target.value);
    //     if (!isNaN(val)) {
    //         setRating(Math.min(5, Math.max(0, val)));
    //     } else {
    //         setRating(0);
    //     }
    // };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        const formData = new FormData();
        formData.append("user_name", userName);
        formData.append("rating", rating);
        formData.append("testimonial", testimonial);
        if (image) {
            formData.append("profile_image", image);
        }

        console.log('=== AddTestimonialModal - Submit ===');
        console.log('  user_name:', userName);
        console.log('  rating:', rating);
        console.log('  testimonial:', testimonial);
        console.log('  image:', image);
        console.log('  FormData entries:');
        for (let [key, value] of formData.entries()) {
            console.log(`    ${key}:`, value);
        }

        onSave(formData);
    };

    if (!showModal) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-container">
                <form className="modal-form" onSubmit={handleSubmit}>
                    <div className="modal-header-inline">
                        <h2 className="modal-title">{isEditMode ? "Edit Testimonial" : "Add New Testimonial"}</h2>
                        <button type="button" className="modal-close-boxy" onClick={onClose} aria-label="Close">
                            <IoClose />
                        </button>
                    </div>

                    {/* 1. Profile Image */}
                    <div className="testimonial-image-upload-section">
                        <label className="testimonial-image-upload-label">Profile Image</label>
                        <div className="testimonial-image-upload-container">
                            {imagePreview ? (
                                <div
                                    className="testimonial-image-preview-wrapper"
                                    onClick={() => fileInputRef.current?.click()}
                                >
                                    <img src={imagePreview} alt="Preview" className="testimonial-image-preview" />
                                </div>
                            ) : (
                                <div
                                    className="testimonial-image-upload-area"
                                    onClick={() => fileInputRef.current?.click()}
                                >
                                    <FaUpload className="testimonial-image-upload-icon" />
                                    <p className="testimonial-image-upload-text">Upload Image</p>
                                </div>
                            )}
                            <input
                                type="file"
                                accept="image/jpeg,image/jpg,image/png"
                                onChange={handleImageChange}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </div>
                    </div>

                    {/* 2. User Name */}
                    <div className="form-group">
                        <label>User Name</label>
                        <input
                            type="text"
                            placeholder="Enter user name"
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                            required
                        />
                    </div>

                    {/* 3. Rating - Stars */}
                    <div className="form-group">
                        <label>Rating</label>
                        <div className="rating-input-row">
                            <div className="star-input-row">
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <FaStar
                                        key={star}
                                        className={`star-icon ${star <= (hoverRating || rating) ? "active" : ""}`}
                                        onClick={() => setRating(star)}
                                        onMouseEnter={() => setHoverRating(star)}
                                        onMouseLeave={() => setHoverRating(0)}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* 4. Testimonial / Feedback */}
                    <div className="form-group">
                        <label>Testimonial / Feedback</label>
                        <textarea
                            placeholder="Write testimonial or feedback here..."
                            rows="4"
                            value={testimonial}
                            onChange={(e) => setTestimonial(e.target.value)}
                            required
                        ></textarea>
                    </div>

                    <div className="modal-actions">
                        <button type="submit" className="save-modal-btn" disabled={saveLoading}>
                            {saveLoading ? (
                                <>
                                    <div className="loading-spinner-small"></div>
                                    Saving...
                                </>
                            ) : (
                                isEditMode ? "Update" : "Save"
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddTestimonialModal;
